<app-header></app-header>

<!-- Hero section -->
<div class="rounded-triangle rd-imgs">
    <div class="section-lg section-fullscreen">
        <div class="container">
            <div class="position-middle">
                <div class="row">
                    <div class="col-12">
                        <h1 class="display-5 fw-black uppercase color-white">.Design Lab</h1>
                        <h2 class="display-4 fw-thin uppercase color-white">Digital Production</h2>
                        <h1 class="display-5 fw-black uppercase color-white">Chaos Agency</h1>
                        <span class="call-us-wrap"><a class="button button-lg button-radius button-blue mt-3" routerLink="/about-us">Read more</a></span>
                        <div class="call-us">
                            <h5 class="color-white">Call Us (0123) 456 - 789</h5>
                            <h6 class="color-white">For any query or concern</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end Hero section -->

<!-- About section -->
<div class="section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-12 heading-style-one box-title-two text-center">
                <h6 class="yellow-color uppercase">About Agency</h6>
                <h2><span class="fw-black">We are an independent<br> strategic advertising <br> agency.</span></h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 mt-4">
            <div class="col-12 col-lg-4 col-xl-4" *ngFor="let feature of features">
                <div class="dn-service-box feature-box-rounded text-center mb-5">
                    <i class="img-icon mb-3" [ngClass]="feature.icon"></i>
                    <h3>{{ feature.title }}</h3>
                    <p>{{ feature.desc }}</p>
                    <p class="mrt-30">
                        <a routerLink="/services" class="button button-md button-rounded" [ngClass]="feature.btnClass">Read More</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end About section -->

<!-- Portfolio section -->
<div class="section-md pd-t-0 skew-bg">
    <div class="container">
        <div class="row">
            <div class="col-12 heading-style-one text-left">
                <h6 class="pink-color uppercase">What We Do</h6>
                <h2><span class="fw-black">Our Best Work</span></h2>
            </div>
        </div>
        <div class="row" *ngFor="let item of portfolios; let i = index" [ngClass]="i != 0 ? 'mrt-50' : 'mrt-100'">
            <!-- LEFT CONTENT -->
            <div class="col-md-6 col-sm-6" [ngClass]="i % 2 == 1 ? 'order-md-2' : ''">
                <div class="row single-portfolio pd-t-60 pd-b-60">
                    <div class="col-md-4 col-sm-4" [ngClass]="i % 2 == 1 ? 'order-md-2' : ''">
                        <h1>{{item.number}}</h1>
                    </div>
                    <div class="col-md-8 col-sm-8" [ngClass]="i % 2 == 1 ? 'text-start order-md-1' : 'text-right'">
                        <div [ngClass]="i % 2 == 1 ? 'single-portfolio-title-left' : 'single-portfolio-title-right'">
                            <h2>{{item.title}}</h2>
                        </div>
                        <p>{{item.desc}}</p>
                    </div>
                </div>
            </div>
        
            <!-- RIGHT IMAGE -->
            <div class="col-md-6 col-sm-6 single-portfolio" [ngClass]="i % 2 == 1 ? 'order-md-1' : ''">
                <img class="img-fluid" [src]="item.image" alt="portfolio">
            </div>
        </div>
    </div>
</div>
<!-- end Portfolio section -->

<!-- Services section -->
<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-12 heading-style-one text-center">
                <h6 class="color-primary uppercase">Why Choose Us</h6>
                <h2 class="display-6 fw-black">We are digital specialists. It's all we do</h2>
            </div>
        </div>
        <div class="row align-items-center mrt-50">
            <div class="col-md-4 main-service-box text-center radius-50" *ngFor="let service of services">
                <i class="bi" [ngClass]="service.icon"></i>
                <h4>{{service.title}}</h4>
                <p>{{service.desc}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12"><div class="triangle-light-blue-big shapes" data-opacity="0.15"></div></div>
        </div>
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- What We Do section -->
<div class="section pd-t-0 pd-b-0">
  <div class="container-fluid pd-0">
    <div class="row row-flex flex-center">
      <div class="col-md-6 col-sm-12">
        <div class="col-inner pd-t-70 pd-b-50 spacer border-top border-bottom">
          <div class="heading-style-one">
            <h6 class="green-color uppercase">What We Do</h6>
            <h2 class="display-6 fw-black">How we build awesome<br>products</h2>
          </div>
          <div class="mrt-30">
          <p>We are an Creative agency, based in New York. Vision Every company is
            performing best online. Mission Helping businesses to find the perfect
            and most succesful strategy, to be online.</p>
            <a class="lightbox-media-box button-circle button-circle-md button-circle-outline-dark button-circle-hover-slide mrt-30" (click)="openPopup()">
              <i class="bi bi-play-fill"></i>
              <i class="bi bi-play-fill"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 bg-flex-cover" style="background-image: url(assets/images/about/about-img.jpg);"></div>
    </div>
  </div>
</div>
<!-- end What We Do section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Testimonial section -->
<div class="section">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Testimonials</h6>
        <h2 class="display-6 fw-black">Our Clients Saying About Us</h2>
      </div>
    </div>
    <owl-carousel-o [options]="testimonialOptions" class="owl-btn-center-lr mrt-80 testimonial-two pd-0">
      <ng-template carouselSlide *ngFor="let tes of testimonials">
          <!-- Testimonial box -->
          <div class="testimonial-item">
              <div class="testimonial-content">
                  <div class="testimonial-content-in">
                      <div class="img">
                          <img class="img-responsive border-radius-100" src="assets/images/team/{{tes.image}}" alt="client-img">
                      </div>
                      <h5>{{tes.name}}</h5>
                      <h6>{{tes.position}}</h6>
                      <p>{{tes.desc}}</p>
                  </div>
              </div>
          </div>
      </ng-template>
  </owl-carousel-o>
    <div class="row">
      <div class="col-md-12">
        <div class="triangle-yellow-big d-sm-block" data-opacity="0.1"></div>
      </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Testimonial section -->

<!-- Blogs section -->
<div class="section-lg pd-b-0">
  <div class="row">
    <div class="col-md-12">
      <div class="square-light-green-big shapes d-sm-block" data-opacity="0.1"></div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Our Blogs</h6>
        <h2 class="display-6 fw-black">Check What Happening Inside Score</h2>
      </div>
    </div>
    <div class="row align-items-center mrt-50">
        <div class="col-md-4" *ngFor="let post of posts">
            <div class="post">
                <div class="post-img">
                    <img class="img-responsive" [src]="post.image" [alt]="post.title">
                </div>
                <div class="post-info">
                    <h3>
                        <a routerLink="/blog-grid">{{ post.title }}</a>
                    </h3>
                    <h6 [ngClass]="post.color">
                        {{ post.category }}
                    </h6>
                    <p>{{ post.time }}</p>
                    <a class="readmore" routerLink="/blog-grid">
                        <span>
                            Read More
                            <i class="eicon bi bi-arrow-right-short"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Blogs section -->
